module.exports = __webpack_public_path__ + "static/media/spotii.9e3426db.png";